import { Copyright } from "./Copyright";

export { Copyright };
